// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsedActivityPreview-cls1___6b76233fdcec7198c19{/*!*/}.CollapsedActivityPreview-cls2___a3ff330b0b22fa5f031{color:#535366;white-space:pre}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsedActivityPreview-cls1___6b76233fdcec7198c19",
	"cls2": "CollapsedActivityPreview-cls2___a3ff330b0b22fa5f031 CollapsedActivityPreview-cls1___6b76233fdcec7198c19"
};
export default ___CSS_LOADER_EXPORT___;
